<i18n>
{
  "en": {
    "menu": "Menu: {0}",
    "service": "Service: {0}",
    "product": "Product: {0}",
    "default": "Default",
    "searching": "searching..."
  },
  "es": {
    "menu": "Menú: {0}",
    "service": "Servicio: {0}",
    "product": "Producto: {0}",
    "default": "Por defecto",
    "searching": "buscando..."
  }
}
</i18n>

<template>
  <v-card class="d-flex flex-column px-3 card-container">
    <div class="d-flex flex-row justify-space-between align-center ml-2">
      <div class="d-flex flex-column">
        <div class="text-h6">{{ bannerRecommendation.title }}</div>
      </div>
      <div>
        <v-btn icon @click="onEdit">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="onDelete">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <dynameat-select-days-week v-if="!bannerRecommendation.activeByDefault"
                               :actualWeekDays="recommendationWeekDict" :readOnly="true"/>
    <div class="d-flex flex-row flex-wrap mt-2">
      <v-chip v-if="bannerRecommendation.activeByDefault" color="#fff685" x-small
              class="mb-1 mr-1">
        <div class="chip-ellipsis">{{ $t('default') }}</div>
      </v-chip>
      <v-chip v-if="bannerRecommendation.product" x-small class="mb-1 mr-1">
        <div class="chip-ellipsis">{{ productNameOk }}</div>
      </v-chip>
      <v-chip x-small class="mb-1 mr-1">
        <div class="chip-ellipsis">{{ menuNameOk }}</div>
      </v-chip>
      <v-chip v-if="!bannerRecommendation.activeByDefault" x-small class="mb-1 mr-1">
        <div class="chip-ellipsis">{{ DateRange }}</div>
      </v-chip>
    </div>
  </v-card>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Components, MapGetters } from '@core/helpers/decorators';
import DynameatSelectDaysWeek from '@dynameat/components/DynameatSelectDaysWeek';
import { MenuBannerRecommendation } from '../models';

@Component
@Components({ DynameatSelectDaysWeek })
@MapGetters(['userLocale'])
export default class RecommendationCard extends Vue {
  @Prop({ type: MenuBannerRecommendation, required: true }) bannerRecommendation;

  @Prop({ required: true }) menuName;

  @Prop({ required: true }) productName;

  onDelete() {
    this.$emit('delete');
  }

  onEdit() {
    this.$emit('edit');
  }

  get productNameOk() {
    const product = this.productName || this.$t('searching');
    return this.$t('product', [product]);
  }

  get menuNameOk() {
    const menu = this.menuName || this.$t('searching');
    return this.$t('menu', [menu]);
  }

  get recommendationWeekDict() {
    return {
      monday: this.bannerRecommendation.monday,
      tuesday: this.bannerRecommendation.tuesday,
      wednesday: this.bannerRecommendation.wednesday,
      thursday: this.bannerRecommendation.thursday,
      friday: this.bannerRecommendation.friday,
      saturday: this.bannerRecommendation.saturday,
      sunday: this.bannerRecommendation.sunday,
    };
  }

  get DateRange() {
    return `${this.bannerRecommendation.timeStart} - ${this.bannerRecommendation.timeEnd}`;
  }
}

</script>

<style scoped>
.chip-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: black;
}

.card-container {
  padding: 10px;
}
</style>
